import * as Redux from 'redux';
import { Dispatch } from 'react-redux';
import { ReportAdministrationView } from './ReportsState';
import { Report, QueryCondition } from '../misc/api/apiTypes';
import * as AdministrationActions from './Administration/AdministrationActions';
import { MainState } from "../Core/reducers";
import { WebPortalLegacyClientInternal } from '../misc/api/WebPortalTokenClient';

declare const rootUrl: string;

export enum ActionType {
    FilterReports = 'FilterReports',
    SortReports = 'SortReports',
    ToggleGetReport = 'ToggleGetReport',
    GetReportFailed = 'GetReportFailed',
    PageReports = 'PageReports',
    RequireStudySelection = 'RequireStudySelection',
    HideWidgets = 'HideWidgets',
    OtherAction = '_OtherAction_',
    ToggleReportModal = 'ToggleReportModal'
}

export class InitializeReportsAsyncAction {
    static async testReportServerConnection(legacyClient: WebPortalLegacyClientInternal, dispatch: Dispatch<MainState>) {
        const success = await legacyClient.testStoredConnection();
        if (success) {
            dispatch(AdministrationActions.ChangeViewAction.create(ReportAdministrationView.Hidden));
        } else {
            dispatch(AdministrationActions.FailedToConnectToReportServerAction.create('Failed to connect to the Report Server. Please check your credentials'));

        }
    }
}

export class RequireStudySelectionAction implements Redux.Action {
    type: ActionType.RequireStudySelection;

    static create(): RequireStudySelectionAction {
        return {
            type: ActionType.RequireStudySelection,
        }
    }
}

export class FilterReportsAction implements Redux.Action {
    type: ActionType.FilterReports;
    member: string;
    condition: QueryCondition;
    value: any;

    static create(member: keyof(Report), condition: QueryCondition, value: any): FilterReportsAction {
        return {
            type: ActionType.FilterReports,
            member: member,
            condition: condition,
            value: value,
        }
    }
}

export class SortReportsAction implements Redux.Action {
    type: ActionType.SortReports;
    member: keyof(Report);

    static create(member: keyof(Report)): SortReportsAction {
        return {
            type: ActionType.SortReports,
            member: member,
        }
    }
}

export enum ReportFormat {
    PDF = 1,
    Excel = 2,
}

export class ToggleGetReportAction implements Redux.Action {
    type: ActionType.ToggleGetReport;
    reportId: string;
    isRequestingDownload: boolean;

    static create(reportId: string, isRequestingDownload: boolean): ToggleGetReportAction {
        return {
            type: ActionType.ToggleGetReport,
            reportId: reportId,
            isRequestingDownload: isRequestingDownload,
        }
    }
}

export class GetReportFailedAction implements Redux.Action {
    type: ActionType.GetReportFailed;
    reportId: string;

    static create(reportId: string): GetReportFailedAction {
        return {
            type: ActionType.GetReportFailed,
            reportId: reportId,
        }
    }
}

export class PageReportsAction implements Redux.Action {
    type: ActionType.PageReports;
    page: number;

    static create(page: number): PageReportsAction {
        return {
            type: ActionType.PageReports,
            page: page,
        }
    }
}

export class HideWidgetsAction implements Redux.Action {
    type: ActionType.HideWidgets;

    static create(): HideWidgetsAction {
        return {
            type: ActionType.HideWidgets,
        }
    }
}

export class OtherAction implements Redux.Action {
    type: ActionType.OtherAction;

    static create(): OtherAction {
        return {
            type: ActionType.OtherAction,
        }
    }
}

export class ToggleReportModalAction implements Redux.Action {
    type: ActionType.ToggleReportModal;
    id?: string;

    static create(id?: string): ToggleReportModalAction {
        return {
            type: ActionType.ToggleReportModal,
            id
        }
    }
}

export type Action = FilterReportsAction | SortReportsAction | ToggleGetReportAction | GetReportFailedAction | PageReportsAction | RequireStudySelectionAction | HideWidgetsAction | OtherAction | ToggleReportModalAction;
